iScreenWizard.controller('MailtemplateController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, Mailtemplate, userService) {

    $scope.mailtemplates = [];
    $scope.userService = userService;
    $scope.focusedMailtemplate = {};
    $scope.searchTerm = '';

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        $scope.loadMailTemplates();
    };
    $scope.refresh = refresh;

    $scope.loadMailTemplates = function() {
        params = {};
        if ($scope.searchTerm.length > 0) {
            params.searchterm = $scope.searchTerm;
        }
        Mailtemplate.all(params).then(function (mailtemplates) {
            $scope.mailtemplates = mailtemplates;
        });
    };

    $scope.searchEmailTemplates = function() {
        $scope.mailtemplates = [];
        $scope.loadMailTemplates();
    };

    $scope.viewMailtemplate = function(mailtemplateId, ev) {
        Mailtemplate.get(mailtemplateId).then(function (mailtemplate) {
            $mdDialog.show({
                controller: MailtempalteShowDialogController,
                locals: {
                    mailtemplate: mailtemplate
                },
                templateUrl: '/mijn-iscreen/mailtemplates/show',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            });

        });
    };

    function MailtempalteShowDialogController($scope, mailtemplate) {
        $scope.mailtemplate = mailtemplate;
    };

    $scope.addMailtemplate = function(ev) {
        $scope.focusedMailtemplate = {};
        $scope.showMailtemplateEditDialog($scope.focusedMailtemplate, ev);
    };

    $scope.editMailtemplate = function(mailtemplate, ev) {
        $scope.focusedMailtemplate = mailtemplate;
        $scope.showMailtemplateEditDialog($scope.focusedMailtemplate, ev);
    };

    var showMailtemplateEditDialog = function(mailtemplate, ev) {
        $mdDialog.show({
            controller: MailtemplateEditDialogController,
            locals: {
                mailtemplate: $scope.focusedMailtemplate
            },
            templateUrl: '/mijn-iscreen/mailtemplates/edit',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        })
    };
    $scope.showMailtemplateEditDialog = showMailtemplateEditDialog;

    function MailtemplateEditDialogController($rootScope, $scope, $mdDialog, mailtemplate) {
        $scope.focusedMailtemplate = mailtemplate;
        $scope.refresh = refresh;
        $scope.showMailtemplateEditDialog = showMailtemplateEditDialog;
        $scope.useHtml = $scope.focusedMailtemplate.id > 0 && $scope.focusedMailtemplate.inhoudhtml.length > 0;

        $scope.trixInitializeMailtemplateTags = $rootScope.trixInitializeMailtemplateTags;

        $scope.saveMailtemplate = function(){
            if ($scope.focusedMailtemplate.id) {
                //update existing
                Ajax.put('mailtemplate/'+$scope.focusedMailtemplate.id, $scope.focusedMailtemplate).then(function (response) {
                    if (response.data.succes) {
                        $scope.refresh();
                        $mdDialog.hide();
                    } else {
                        ErrorHandler.showDialog(response, $scope.showMailtemplateEditDialog($scope.focusedMailtemplate));
                    }
                }, function (exception) {
                    //something went wrong
                    ErrorHandler.showDialog(exception);
                });
            } else {
                //add new
                $scope.focusedMailtemplate.senderemail = userService.model.email;
                Ajax.post('mailtemplate', $scope.focusedMailtemplate).then(function (response) {
                    if (response.data.succes) {
                        $scope.refresh();
                        $mdDialog.hide();
                    } else {
                        ErrorHandler.showDialog(response).then($scope.showMailtemplateEditDialog($scope.focusedMailtemplate));
                    }
                }, function (exception) {
                    ErrorHandler.showDialog(exception);
                });
            }
        };
    }

    $scope.deleteMailtemplate = function(mailtemplate, ev) {
        $scope.showMailtemplateDeleteDialog(mailtemplate, ev).then(function() {
            //delete mailtemplate if user confirmed
            Ajax.delete('mailtemplate/'+mailtemplate.id).then(function (response) {
                if (response.data.succes) {
                    $scope.refresh();
                    $mdDialog.hide();
                } else {
                    ErrorHandler.showDialog(response);
                }
            }, function (exception) {
                //something went wrong
                ErrorHandler.showDialog(exception);
            });
        });
    };

    $scope.showMailtemplateDeleteDialog = function(mailtemplate, ev) {
        return $mdDialog.show(
            $mdDialog.confirm()
                .title(Dictionary.translate('app.delete_mailtemplate', true))
                .htmlContent(Dictionary.translate('app.confirm_delete', true))
                .ariaLabel(Dictionary.translate('app.delete_mailtemplate', true))
                .ok(Dictionary.translate('app.okay', true))
                .cancel(Dictionary.translate('app.cancel', true))
        );
    };

});